import { jsx as _jsx } from "react/jsx-runtime";
import { DevTool } from '@hookform/devtools';
/**
 * Conditionally renders a React Hook Form DevTool component if the process.env.NODE_ENV is set to 'development'
 *
 * @param {RHFDevToolProps} props
 *  @property {RHFDevToolProps.control} control - The control to render
 *  @property {RHFDevToolProps.placement} placement - The placement of the devtool
 * @returns {React.ReactNode | null}
 */
var RHFDevTool = function (_a) {
    var control = _a.control, _b = _a.placement, placement = _b === void 0 ? 'top-right' : _b;
    return process.env.NODE_ENV === 'development' ? (_jsx(DevTool, { control: control, placement: placement })) : null;
};
export default RHFDevTool;
